import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFieldInputMaskComponent } from './form-field-input-mask.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { NgxMaskModule } from 'ngx-mask';


@NgModule({
  declarations: [
    FormFieldInputMaskComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    NgxMaskModule
  ],
  exports: [ FormFieldInputMaskComponent ]
})
export class FormFieldInputMaskModule { }
